// includes guard so that the reference to window doesn't break unit tests
export const $ = typeof window !== 'undefined' ? window.jQuery : null;
